module.exports = __webpack_public_path__ + "static/media/recommendedf1.c987ab27.png";